import { flow, find, get, tap } from 'lodash/fp';
import * as designBuilderApi from '../api/designBuilder';
import globalError from './globalError';
import estimateLoaded from './estimateLoaded';
import loaded from './loaded';
import loading from './loading';

export default (newValue, itemId, attributeName, reason = null) => (dispatch, getState) => {
  dispatch(loading());
  const item = get(`estimateBuilder.entities.items.byId.${itemId}`)(getState());
  const designId = get('designId')(item);
  const attributeId = flow(
    get('attributes'),
    find({ name: attributeName }),
    get('attributeId'),
  )(item);

  return designBuilderApi
    .setItemAttribute(designId, itemId, attributeId, newValue, reason)
    .then(design => dispatch(estimateLoaded(design)))
    .then(tap(() => dispatch(loaded())))
    .catch(err => dispatch(globalError({ err })));
};
